/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
const BaseClass = require('gemini/lib/@waca/dashboard-common/dist/glass/controllers/BaseSlideoutActionHandler');

const RESIZABLE_HANDLE = 12;
const DEFAULT_WIDTH = 270 + RESIZABLE_HANDLE;
const MAX_WIDTH = 1000;

const CardGridSlideoutActionHandler = BaseClass.extend({

	getExtraCustomSpec: function(context) {
		var options = {
			id: 'dashboardPanel',
			reuseSlideout: true,
			width: `${DEFAULT_WIDTH}px`,
			position: 'left',
			resizable: {
				min: DEFAULT_WIDTH,
				max: MAX_WIDTH
			},
			pinning: {
				isPinned: true,
				float: false,
				display: false
			},
			content: {
				module: 'explore/contrib/cards/extension',
				glassContext: context.glassContext
			}
		};
		return options;
	}
});

export default CardGridSlideoutActionHandler;



// WEBPACK FOOTER //
// ./src/js/glass/controllers/CardGridSlideoutActionHandler.js